// extracted by mini-css-extract-plugin
export var circle = "_43-2";
export var icon = "_43-a";
export var iconHighlight = "_43-0";
export var lg = "_43-8";
export var md = "_43-7";
export var outline = "_43-4";
export var sm = "_43-6";
export var square = "_43-1";
export var xl = "_43-9";
export var xs = "_43-5";
export var xxs = "_43-3";